module.exports = __webpack_public_path__ + "static/certificato-iso-9001-2015-materia3-1be28e87367e70ed203987dae26d0fa1.pdf";